import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ settings: null });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api
      .get("/public/settings")
      .then((r) => setSettings(r.data))
      .catch(() => setSettings(null));
  }, []);
  return <Ctx.Provider value={{ settings }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);
